module.exports = __webpack_public_path__ + "static/img/专科护理@3x.fw.5ebc4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/nav/专科护理@3x.fw.png
// module id = 780
// module chunks = 358